import React from 'react';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  addButton: {
    marginBottom: theme.spacing(1.25),
    marginLeft: theme.spacing(1),
  },
}));
export const AddRealAssetButton = () => {
  const classes = useStyles();
  return (
    <Button
      aria-label="edit"
      size="small"
      className={classes.addButton}
      color="secondary"
      onClick={() => {
        openModal(modalConsts.realAssetModal);
      }}
    >
      <AddIcon />
      Add Real Asset
    </Button>
  );
};

AddRealAssetButton.defaultProps = {
};

AddRealAssetButton.propTypes = {
};
